/**
 * Generated by orval 🍺
 * Do not edit manually.
 * clarityrcm.api
 * OpenAPI spec version: 1.0
 */

/**
 * Display payment state for a statement row, derived from summed succeeded payments vs the statement
 * amount (partial payments reported correctly). Distinct from the persisted
 * clarityrcm.shared.Models.StatementPaymentStatus / clarityrcm.shared.Models.StatementStatus lifecycle values.
 */
export type PaymentDisplayStatus =
  (typeof PaymentDisplayStatus)[keyof typeof PaymentDisplayStatus];

export const PaymentDisplayStatus = {
  Unpaid: "Unpaid",
  PartiallyPaid: "PartiallyPaid",
  Paid: "Paid",
  External: "External",
  Cancelled: "Cancelled",
} as const;
